module.exports = __webpack_public_path__ + "static/media/sun-glasses-6.5f933fd5.jpg";